import PhoneNumberDisplay from './PhoneNumberDisplay'

export default PhoneNumberDisplay;